<template>
  <v-layout>
    <v-expansion-panel expand>
      <v-expansion-panel-content v-for="(question,i) in questions" :key="i">
        <div slot="header"><strong>Question:</strong> {{ question.question }}</div>
        <v-card>
          <v-card-text class="grey darken">
            <v-btn @click="onClick(question.id)" class="primary">Add Choice</v-btn>
            <choice
              :apiUrl="apiUrl"
              :questionId="question.id"
              :choices="question.choices"
            ></choice>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-dialog
      v-model="addChoiceForm"
    >
      <add-choice-form
        :apiUrl="apiUrl"
        :selectedQuestionId="selectedQuestionId"
      ></add-choice-form>
    </v-dialog>
  </v-layout>
</template>

<script>
import axios from 'axios'
import Choice from '@/components/admin/module/question/choice'
import AddChoiceForm from '@/components/admin/module/question/addChoiceForm'
import config from '../../../../../configApi'
const apiUrl = config.apiUrl

export default {
  components: {
    Choice,
    AddChoiceForm
  },
  data () {
    return {
      addChoiceForm: false,
      questions: [],
      selectedQuestionId: null
    }
  },
  methods: {
    onClick (questionId) {
      console.log(questionId)
      this.selectedQuestionId = questionId
      console.log(this.selectedQuestionId)
      this.addChoiceForm = true
    },
    getQuestionsByModuleId (moduleId) {
      axios.get(apiUrl + '/questionnaire/module/' + moduleId).then((res) => {
        console.log(res.data)
        this.questions = res.data
      })
    }
  },
  mounted () {
    this.getQuestionsByModuleId(this.moduleId)
  },
  props: {
    apiUrl: String,
    moduleId: String
  }
}
</script>


// WEBPACK FOOTER //
// src/components/admin/module/question/index.vue